import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFormatItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M200-200v-100h160l120-360H320v-100h400v100H580L460-300h140v100H200Z" })
});
export default SvgFormatItalic;
